/*
 * mf-product-notify-soldout.js — Back-in-stock a nivel producto.
 * Standalone (NO toca el bundle minificado mf-product-hero.js). Se activa solo
 * cuando el producto está TOTALMENTE agotado (1 variante agotada o multi todo OOS);
 * el picker por chips ya cubre el caso "alguna variante disponible".
 * POST al mismo Worker que el notify de variantes: /subscribe.
 */
(function () {
  var ENDPOINT = 'https://mf-back-in-stock.mundofit.workers.dev/subscribe';

  function init(root) {
    var trigger = root.querySelector('[data-soldnotify-trigger]');
    var panel = root.querySelector('[data-soldnotify-panel]');
    var form = root.querySelector('[data-soldnotify-form]');
    var email = root.querySelector('[data-soldnotify-email]');
    var msg = root.querySelector('[data-soldnotify-msg]');
    if (!trigger || !panel || !form || !email) return;

    function showMsg(text, kind) {
      if (!msg) return;
      msg.textContent = text;
      msg.removeAttribute('hidden');
      msg.className = 'mf-ph-soldnotify__msg' + (kind ? ' is-' + kind : '');
    }

    trigger.addEventListener('click', function () {
      var isOpen = !panel.hasAttribute('hidden');
      if (isOpen) {
        panel.setAttribute('hidden', '');
        trigger.setAttribute('aria-expanded', 'false');
      } else {
        panel.removeAttribute('hidden');
        trigger.setAttribute('aria-expanded', 'true');
        email.focus();
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var addr = (email.value || '').trim();
      if (!addr) return;
      var submit = form.querySelector('[type="submit"]');
      if (submit) submit.disabled = true;
      showMsg('Enviando…', '');

      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: addr,
          variant_id: root.getAttribute('data-variant-id'),
          product_title: root.getAttribute('data-product-title') || '',
          product_url: window.location.href,
          product_image: root.getAttribute('data-product-image') || ''
        })
      })
        .then(function (res) {
          if (res.ok) {
            showMsg('¡Listo! Te avisaremos por correo apenas vuelva.', 'ok');
            form.reset();
          } else {
            showMsg('No pudimos registrarte. Intenta de nuevo.', 'err');
          }
        })
        .catch(function () {
          showMsg('Error de conexión. Intenta de nuevo.', 'err');
        })
        .then(function () {
          if (submit) submit.disabled = false;
        });
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-soldnotify]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
